import {type EnhancedMenu} from '~/lib/utils';
import {Drawer, Text, Link} from '~/components';
import type {LayoutData} from '../root';
import Footer from '~/components/_App/Footer';
import * as _ from 'lodash';

export function Layout({
  children,
  footer,
  meta,
}: {
  children: React.ReactNode;
  footer?: any;
  meta?: any;
}) {
  return (
    <>
      <div className="flex flex-col min-h-screen">
        <main role="main" id="mainContent" className="flex-grow">
          {children}
        </main>
      </div>
      <Footer footer={footer} meta={meta} />
    </>
  );
}

export function MenuDrawer({
  isOpen,
  onClose,
  menu,
}: {
  isOpen: boolean;
  onClose: () => void;
  menu: EnhancedMenu;
}) {
  return (
    <Drawer open={isOpen} onClose={onClose} openFrom="left" heading="Menu">
      <div className="grid">
        <MenuMobileNav menu={menu} onClose={onClose} />
      </div>
    </Drawer>
  );
}

function MenuMobileNav({
  menu,
  onClose,
}: {
  menu: EnhancedMenu;
  onClose: () => void;
}) {
  return (
    <nav className="grid gap-4 p-6 sm:gap-6 sm:px-12 sm:py-8">
      {/* Top level menu items */}
      {(menu?.items || []).map((item) => (
        <span key={item.id} className="block">
          <Link
            to={item.to}
            target={item.target}
            onClick={onClose}
            className={({isActive}) =>
              isActive ? 'pb-1 border-b -mb-px' : 'pb-1'
            }
          >
            <Text as="span" size="copy">
              {item.title}
            </Text>
          </Link>
        </span>
      ))}
    </nav>
  );
}
